import { useState } from 'react';
import { cookieExists, setCookie } from '../hooks/useCookieManager';
import { Button } from './Button';

export const CookieNotice = () => {
  const checkForCookieAcceptance = () => {
    const showNotice = false;

    if (cookieExists('cookieNoticeAccepted') === false) {
      return true;
    }

    return showNotice;
  };
  const [showCookieNotice, setShowCookieNotice] = useState(checkForCookieAcceptance());

  const cookiesRejectedRedirect = () => {
    window.location.href = 'https://siemens.com';
  };

  const saveAcceptenceCookieAndCloseBanner = () => {
    setCookie('cookieNoticeAccepted', 'true', 5);
    setShowCookieNotice(false);
  };

  if (!showCookieNotice) return null;

  return (
    <div>
      <div className="fixed top-0 left-0 bottom-0 w-full h-screen bg-solid-deep-blue z-10 opacity-70"></div>
      <div className="mr-[30%] fixed top-1/3 left-1/3 z-10 p-10 bg-elevation-1 pl-12 pr-12">
        <h1 className="mb-3 text-xl font-bold">Cookie Notice</h1>
        <p>
          By clicking “Accept and Continue”, you agree to the storing of cookies on your device that are
          required solely for the purpose of enabling site features. Deletion or rejection of cookies will
          result in navigation away from this site. Cookies are not used for any marketing or tracking
          purposes.
        </p>
        <Button
          text="Reject and Exit Site"
          primary={true}
          onClick={cookiesRejectedRedirect}
          disabled={false}
          className="mt-2 mr-4"
        />
        <Button
          text="Accept and Continue"
          primary={true}
          onClick={saveAcceptenceCookieAndCloseBanner}
          disabled={false}
          className="mt-2"
        />
      </div>
    </div>
  );
};
